import Enum from "../../../../../enums/Enum";

const PrescriptionTimeUnitEnum = new Enum({
    DAY: {name: "Day", days: 1},
    WEEK: {name: "Week", days: 7},
    MONTH: {name: "Month", days: 30},
    YEAR: {name: "Year", days: 365}
});

export default PrescriptionTimeUnitEnum;